/* =================================================================
   一沙一世界 · 全部静态数据
   ================================================================= */

const PROJECT = {
  name: '一沙一世界',
  subtitle: '银川八小 · 五年级 · AI 学习力跨学科项目',
  motto: '一粒沙里见世界，一节课中育未来',
  intro: '从一粒沙出发，走进贺兰山、黄河、毛乌素、海宝塔——地理、生态、工程、艺术、传统、生命、时间与商业的九重世界。',
  schoolName: '银川八小',
  region: '宁夏银川',
  grade: '五年级',
};

const STAGES = [
  { key: 'learn',  title: '学', name: '学的地层', icon: '📖', accent: '#c9a875',
    intro: '走进资料，理解角色任务的来龙去脉。', verb: '探索资料' },
  { key: 'ask',    title: '问', name: '问的山口', icon: '❓', accent: '#d49f3a',
    intro: '把好奇心变成清楚的问题，问出方向。', verb: '提出问题' },
  { key: 'think',  title: '思', name: '思的绿洲', icon: '💭', accent: '#6ea674',
    intro: '画图、写计划、做设计，把想法变成方案。', verb: '构思方案' },
  { key: 'debate', title: '辨', name: '辨的风谷', icon: '🗣️', accent: '#a85a32',
    intro: '比较方案、听取反馈、说出你的理由。', verb: '辨析改进' },
  { key: 'act',    title: '行', name: '行的高地', icon: '🚀', accent: '#7e4f23',
    intro: '完成作品、上台讲解、把成果带回海宝塔。', verb: '完成展示' },
];

const RUBRIC_DIMS = [
  { key: 'task',     name: '任务完成度', desc: '是否按阶段完成必要任务和提交物' },
  { key: 'thinking', name: '思考质量',   desc: '问题是否清楚，方案是否有理由，反思是否具体' },
  { key: 'evidence', name: '证据质量',   desc: '上传材料是否真实、清楚、能证明学习过程' },
  { key: 'express',  name: '表达/协作', desc: '讲解、路演、团队分工、同伴反馈表现' },
];

/* ============== 9 个角色分智能体 ============== */

const ROLES = [
  {
    id: 'sand-table',
    className: '五1班',
    classCode: 'WU1',
    teamName: '沙盘组',
    roleName: '地质沙盘工程师',
    fullName: '沙盘组｜地质沙盘工程师',
    emoji: '🏔️',
    color: '#a96f2a',
    bg: 'linear-gradient(160deg,#f1cf86,#a96f2a)',
    tagline: '把山川河湖装进一桌沙盘',
    mission: '用沙、土、水、彩泥还原一片真实地貌——贺兰山、黄河、腾格里沙漠、宁夏平原绿洲，让一年级也看懂"地球的脸"。',
    materials: [
      { type: '资料包', title: '认识地形：山地·平原·高原·盆地·丘陵', summary: '通过卫星图、立体图、剖面图，识别 5 种基本地形。' },
      { type: '案例',   title: '银川周边地形地貌', summary: '贺兰山如脊、黄河"几"字弯、银川平原绿洲、东边毛乌素与西边腾格里。' },
      { type: '工具',   title: '沙盘制作三要素', summary: '沙土比例、湿度控制、等高线堆叠手法。' },
      { type: '参考',   title: '"一沙一世界"沙盘组组员手册', summary: '小组分工：地形师、河流师、城建师、解说员。' },
    ],
    keywords: ['地形','等高线','地质','沙盘','分层','河流','山脉','盆地','侵蚀','沉积'],
    stageTasks: {
      learn:  '阅读《认识五种地形》资料，记录至少3个让你惊讶的事实；在沙盘示意图上指出山地、河流、平原各在哪里。',
      ask:    '我们要做的沙盘要还原什么地点？为什么是这里？你最想搞清楚的1个地理问题是什么？',
      think:  '为你们小组的沙盘画一张俯视草图：标出山、河、城、绿、沙；写出每种材料用什么代替（颜色、比例）。',
      debate: '和组员比较两版草图，挑出更合理的一版，并写出理由。听一次老师/同伴的建议后做修改。',
      act:    '完成沙盘实体，拍3张照片（正面/俯视/细节），录一段30秒讲解：这片土地讲了什么故事？',
    },
  },
  {
    id: 'sports',
    className: '五2班',
    classCode: 'WU2',
    teamName: '体育游戏组',
    roleName: '沙地运动设计师',
    fullName: '体育游戏组｜沙地运动设计师',
    emoji: '🏃',
    color: '#c97b4b',
    bg: 'linear-gradient(160deg,#f6c89c,#c97b4b)',
    tagline: '把老祖宗的游戏，重新跑起来',
    mission: '从打沙包、跳房子、滚铁环、推沙球出发，设计一套适合校园场地的"沙之传统游戏"。',
    materials: [
      { type: '资料包', title: '中国传统体育游戏图鉴', summary: '20个濒临遗忘的童年游戏：打沙包、跳皮筋、踢毽子、滚铁环…' },
      { type: '案例',   title: '一年级合作游戏：沙包送家', summary: '低年级如何用沙包学合作和数数。' },
      { type: '工具',   title: '游戏设计四要素', summary: '场地·道具·规则·安全。' },
      { type: '参考',   title: '运动会项目策划模板', summary: '招商大会上家长可以玩什么沙地游戏？' },
    ],
    keywords: ['沙包','跳房子','规则','队伍','胜负','合作','安全','场地','计分','计时'],
    stageTasks: {
      learn:  '了解至少5个传统沙地/沙包游戏；记录每个游戏的"年代/玩法/记忆点"。',
      ask:    '哪一个游戏最适合改造给一年级小朋友玩？你担心的安全问题是什么？',
      think:  '写一份游戏设计书：名字、玩法、人数、道具、3条规则、1条安全提醒、画一张场地图。',
      debate: '把你的设计在小组里"试玩想象"，找出2处不合理的地方并修改。',
      act:    '组织一次5分钟试玩，录视频；写下试玩后家长/同学的1条反馈和你的1点感想。',
    },
  },
  {
    id: 'invest',
    className: '五3班',
    classCode: 'WU3',
    teamName: '点沙成金',
    roleName: '招商策划师',
    fullName: '点沙成金｜招商策划师',
    emoji: '💼',
    color: '#b8852c',
    bg: 'linear-gradient(160deg,#f3d479,#8a5e10)',
    tagline: '一粒沙，也能讲出一个故事',
    mission: '为"一沙一世界"项目设计一场招商大会展位：白皮书、路演、互动体验，让家长嘉宾愿意参与。',
    materials: [
      { type: '资料包', title: '什么是招商？什么是路演？', summary: '把商业概念翻译成五年级能听懂的话。' },
      { type: '案例',   title: '校园市集创业小队故事', summary: '别的学校怎么把课程变成展位。' },
      { type: '工具',   title: '展位三件套', summary: '展板、白皮书、互动体验区。' },
      { type: '参考',   title: '路演稿模板：1分钟说清"我们卖什么"', summary: '从1句话到1分钟，节奏怎么走。' },
    ],
    keywords: ['招商','展位','白皮书','路演','客户','故事','价格','卖点','体验','合作'],
    stageTasks: {
      learn:  '读《校园招商小百科》，写下"什么是招商"的3句话定义；找出1个你最喜欢的案例并说为什么。',
      ask:    '我们这次招商大会想"卖"的是什么？谁是我们的客户？他们为什么要听？',
      think:  '画出展位草图（含展板、互动区、座位）；写一份1分钟路演稿（180字以内）。',
      debate: '在小组里互讲路演稿；挑出2句最打动人的，2句最容易被忽略的，修改一遍。',
      act:    '完成最终路演稿、展板说明、白皮书摘要；录一段1分钟路演视频。',
    },
  },
  {
    id: 'tower',
    className: '五4班',
    classCode: 'WU4',
    teamName: '基建组',
    roleName: '夯土工程师',
    fullName: '基建组｜夯土工程师',
    emoji: '🧱',
    color: '#7e4f23',
    bg: 'linear-gradient(160deg,#dcb079,#5b3a1f)',
    tagline: '一锤一夯，造一座属于银川的海宝塔',
    mission: '研究夯土、糯米灰浆、版筑工艺，亲手做一座 1:50 的"海宝塔（北塔）"模型，让千年技艺在校园重生。',
    materials: [
      { type: '资料包', title: '夯土的秘密：从黄土高原到西夏王陵', summary: '夯土材料、湿度、层厚、抗震原理；西夏王陵的夯土城墙为什么能站立 900 多年。' },
      { type: '案例',   title: '海宝塔（北塔）的历史与象征', summary: '它经历了哪些朝代？为什么被叫"北塔"？又为什么在地震和岁月里依然挺立？' },
      { type: '工具',   title: '基建组学生手册', summary: '工序：选土→配料→夯筑→养护→修饰。' },
      { type: '参考',   title: '安全施工：小工程师的 5 条军规', summary: '不徒手抓泥、不站高凳、不独自施工…' },
    ],
    keywords: ['夯土','版筑','海宝塔','北塔','糯米灰浆','层','抗震','工序','工地','配比','结构'],
    stageTasks: {
      learn:  '看《夯土的秘密》视频与图文，画一张"夯土工序流程图"，标注每一步的关键动作。',
      ask:    '海宝塔为什么能立这么多年？我们要重建它的"什么"？你想试验的 1 种材料配比是什么？',
      think:  '画出 1:50 海宝塔模型设计图：层数、底座、用料、人员分工；列一份施工计划（5天）。',
      debate: '和同伴比较两种配比的小样，记录哪一种更结实、为什么；选出最终方案。',
      act:    '完成模型施工，拍下"开工/夯第 3 层/封顶/合影"4 张里程碑照片；写一篇 200 字工程日志。',
    },
  },
  {
    id: 'ecology',
    className: '五5班',
    classCode: 'WU5',
    teamName: '生态组',
    roleName: '生态修复师',
    fullName: '生态组｜生态修复师',
    emoji: '🌱',
    color: '#4f8a5b',
    bg: 'linear-gradient(160deg,#c4e1b8,#356f49)',
    tagline: '让沙退一步，让绿走一步',
    mission: '了解中国治沙故事——三北防护林、库布其、毛乌素，设计一份"校园角落微治沙"方案。',
    materials: [
      { type: '资料包', title: '中国治沙四十年', summary: '从三北防护林到库布其奇迹。' },
      { type: '案例',   title: '一棵柠条如何稳住一片沙', summary: '植物根系与沙地保水原理。' },
      { type: '工具',   title: '校园观察日记法', summary: '5分钟看懂一片土壤。' },
      { type: '参考',   title: '微治沙方案模板', summary: '在校园选一块"小沙地"，做一份90天计划。' },
    ],
    keywords: ['治沙','防护林','根系','土壤','水分','植被','沙化','气候','生态','修复'],
    stageTasks: {
      learn:  '读3个治沙故事，挑出最打动你的1个，写下：他们花了多久？用了什么方法？最大的困难是什么？',
      ask:    '校园里最像"小沙地"的角落在哪？你能问出3个关于这块地的科学问题吗？',
      think:  '设计一份"90天校园微治沙"计划：选址、植物、浇水、护土、记录方式；画一张选址平面图。',
      debate: '听一位老师/同伴的建议，修改方案，写明你接受/不接受的理由。',
      act:    '完成第1次实地观察+1次植物试种，拍照记录；写一份观察日记（含数据：温度、湿度、植物状态）。',
    },
  },
  {
    id: 'sound',
    className: '五6班',
    classCode: 'WU6',
    teamName: '沙之音',
    roleName: '声音戏剧导演',
    fullName: '沙之音｜声音戏剧导演',
    emoji: '🎭',
    color: '#a85a32',
    bg: 'linear-gradient(160deg,#f0bda0,#7a3f1f)',
    tagline: '风吹过沙的声音，也能写进剧本',
    mission: '用沙的声音(沙铃、沙锤、沙画、脚步)做素材，编排一出5分钟"沙之音"声音剧场。',
    materials: [
      { type: '资料包', title: '声音的形状：自然之声入门', summary: '风声、沙声、水声、脚步——它们能拼出故事吗？' },
      { type: '案例',   title: '《沙漠驼铃》音乐剧片段', summary: '看别人怎么用一种声音讲一段路。' },
      { type: '工具',   title: '声音剧本模板', summary: '场景·声音·人物·情绪四列法。' },
      { type: '参考',   title: '校园录音指南', summary: '用手机录到不糊的"干净沙声"的5个技巧。' },
    ],
    keywords: ['声音','节奏','剧本','情绪','沙铃','录音','旁白','配乐','演出','场景'],
    stageTasks: {
      learn:  '收集3种"沙的声音"录音（沙铃/抓沙/脚步），听一遍，写下每段声音让你想到什么画面。',
      ask:    '你想用这些声音讲一个什么样的故事？故事里最关键的1个转折是什么？',
      think:  '写一份5分钟声音剧本：场景、声音、人物、情绪四列；为剧本起一个名字。',
      debate: '组员互听剧本初版，挑出最有画面感的1段、最模糊的1段，给出修改建议。',
      act:    '完成正式录音 + 1次现场演出，拍剧照、上传录音；写下你听完成品后的感受。',
    },
  },
  {
    id: 'biology',
    className: '五7班',
    classCode: 'WU7',
    teamName: '沙生动植物组',
    roleName: '沙漠生物学家',
    fullName: '沙生动植物组｜沙漠生物学家',
    emoji: '🦎',
    color: '#92651e',
    bg: 'linear-gradient(160deg,#e9c98b,#7c5210)',
    tagline: '在最干的地方，藏着最聪明的生命',
    mission: '研究沙漠动植物的"求生策略"，做一份"沙漠生物名片册"，挑1种最爱的生物在路演上讲清楚。',
    materials: [
      { type: '资料包', title: '沙漠动植物图鉴：骆驼·梭梭·胡杨·跳鼠·沙蜥', summary: '形态·习性·绝活。' },
      { type: '案例',   title: '胡杨的"生而千年不倒"', summary: '一种树能教我们什么坚持？' },
      { type: '工具',   title: '生物名片模板', summary: '名字·分布·绝活·趣事·一句话推荐。' },
      { type: '参考',   title: '科普讲解的"3-2-1"结构', summary: '3个事实·2个比喻·1个故事。' },
    ],
    keywords: ['骆驼','梭梭','胡杨','跳鼠','沙蜥','节水','根系','适应','生态位','繁殖'],
    stageTasks: {
      learn:  '通读图鉴，挑出3种你最感兴趣的沙漠生物，分别写下它们"为什么能活下来"。',
      ask:    '你最想替哪种生物"代言"？它的最大对手是谁？它最依赖的伙伴是谁？',
      think:  '为你选中的生物制作一张"生物名片"（形态、绝活、趣事、一句话推荐），可以画+文字。',
      debate: '在组内互讲名片，听同伴提出1个你没注意到的"小知识点"，把它加进名片。',
      act:    '完成最终名片+1分钟讲解视频；写下你对"生命的力量"的1句话理解。',
    },
  },
  {
    id: 'clock',
    className: '五8班',
    classCode: 'WU8',
    teamName: '沙之时钟',
    roleName: '地质时间策展人',
    fullName: '沙之时钟｜地质时间策展人',
    emoji: '⏳',
    color: '#a3672a',
    bg: 'linear-gradient(160deg,#f0d39c,#7e5024)',
    tagline: '把漫长时间，变成看得见的刻度',
    mission: '把46亿年地质时间压缩成一段"沙漏长廊"，让看的人在30步里走完地球的一生。',
    materials: [
      { type: '资料包', title: '地球46亿年：大事年表', summary: '从形成→生命→恐龙→人类，刻在一条时间轴上。' },
      { type: '案例',   title: '"沙漏长廊"策展案例', summary: '别的博物馆怎么把时间"看得见"。' },
      { type: '工具',   title: '比例换算法', summary: '46亿年 ↔ 30步：每一步代表多少年？' },
      { type: '参考',   title: '展品说明卡模板', summary: '标题·年份·一句话·配图。' },
    ],
    keywords: ['46亿年','地质年代','寒武纪','恐龙','冰期','人类','比例','时间轴','沙漏','策展'],
    stageTasks: {
      learn:  '通读地球大事年表，挑出8个你认为最该展示的时刻，写下你为它选的1句"展品文字"。',
      ask:    '如果只能让观众记住3件事，应该是哪3件？为什么？',
      think:  '设计一条30步沙漏长廊：每步代表多少年？每步该有什么展品？画一张布展平面图。',
      debate: '请同伴走一遍"想象长廊"，记下他卡顿/兴奋的地方，据此修改展品和文字。',
      act:    '完成展品制作和最终布展、拍3张照片，写一段150字策展手记。',
    },
  },
  {
    id: 'sand-art',
    className: '美术组',
    classCode: 'ART',
    teamName: '沙话美陈组',
    roleName: '沙画空间设计师',
    fullName: '沙话美陈组｜沙画空间设计师',
    emoji: '🎨',
    color: '#d49f3a',
    bg: 'linear-gradient(160deg,#f7dfa3,#a37a1a)',
    tagline: '让整个学校成为一座沙的展厅',
    mission: '用沙画、沙瓶、沙地装置作品，把走廊、楼梯、橱窗变成"一沙一世界"主题美陈空间。',
    materials: [
      { type: '资料包', title: '沙画基础：从一粒沙到一幅画', summary: '工具、手法、构图。' },
      { type: '案例',   title: '校园美陈案例：把走廊变成画廊', summary: '主题、色彩、动线。' },
      { type: '工具',   title: '美陈三大原则', summary: '主题统一·节奏控制·安全易换。' },
      { type: '参考',   title: '沙瓶分层艺术', summary: '不同颜色沙的层次美学。' },
    ],
    keywords: ['沙画','沙瓶','美陈','色彩','构图','装置','空间','主题','光','动线'],
    stageTasks: {
      learn:  '看3个沙画/美陈案例，写下你最喜欢的1个，记录它打动你的1个细节。',
      ask:    '校园里哪一面墙、哪一个角落最值得"变身"？观众走过它时，你希望他停留几秒？',
      think:  '为选定的空间画一张"美陈效果图"（手绘或拼贴）+ 一张"工艺清单"。',
      debate: '在组内对比两版方案，听老师/同伴对"主题表达"的反馈，整合一版终稿。',
      act:    '完成实际布展和现场拍摄，写一段100字策展者自述：你想让观众带走什么？',
    },
  },
];

const ROLES_BY_ID = Object.fromEntries(ROLES.map(r => [r.id, r]));
const ROLES_BY_CODE = Object.fromEntries(ROLES.map(r => [r.classCode, r]));

/* ============== 教师账号 ============== */

const TEACHERS = [
  { id: 't-lead',  name: '林老师', code: 'TEACH', role: 'lead',   subjectLabel: '项目总协调' },
];

/* ============== 演示学生 (每班 2-4 人，预先打开局部进度) ============== */

const DEMO_STUDENTS = [
  // 五1班
  { id: 's-w1-01', name: '陆星瑶', class: '五1班', roleId: 'sand-table', team: '沙盘 A 组', progress: 'act' },
  { id: 's-w1-02', name: '周予安', class: '五1班', roleId: 'sand-table', team: '沙盘 A 组', progress: 'debate' },
  { id: 's-w1-03', name: '黄子睿', class: '五1班', roleId: 'sand-table', team: '沙盘 B 组', progress: 'think' },
  // 五2班
  { id: 's-w2-01', name: '吴一鸣', class: '五2班', roleId: 'sports', team: '游戏 A 组', progress: 'debate' },
  { id: 's-w2-02', name: '钱沐辰', class: '五2班', roleId: 'sports', team: '游戏 A 组', progress: 'think' },
  { id: 's-w2-03', name: '宋疏桐', class: '五2班', roleId: 'sports', team: '游戏 B 组', progress: 'ask' },
  // 五3班
  { id: 's-w3-01', name: '陈知意', class: '五3班', roleId: 'invest', team: '招商 A 组', progress: 'act' },
  { id: 's-w3-02', name: '何思齐', class: '五3班', roleId: 'invest', team: '招商 B 组', progress: 'think' },
  // 五4班
  { id: 's-w4-01', name: '林沐沐', class: '五4班', roleId: 'tower', team: '基建 A 组', progress: 'debate' },
  { id: 's-w4-02', name: '杨梓墨', class: '五4班', roleId: 'tower', team: '基建 A 组', progress: 'think' },
  { id: 's-w4-03', name: '张子皓', class: '五4班', roleId: 'tower', team: '基建 B 组', progress: 'learn' },
  // 五5班
  { id: 's-w5-01', name: '苏明朗', class: '五5班', roleId: 'ecology', team: '生态 A 组', progress: 'think' },
  { id: 's-w5-02', name: '叶清晏', class: '五5班', roleId: 'ecology', team: '生态 A 组', progress: 'ask' },
  // 五6班
  { id: 's-w6-01', name: '徐昭言', class: '五6班', roleId: 'sound', team: '沙之音 A 组', progress: 'act' },
  { id: 's-w6-02', name: '韩亦舟', class: '五6班', roleId: 'sound', team: '沙之音 B 组', progress: 'debate' },
  // 五7班
  { id: 's-w7-01', name: '罗一帆', class: '五7班', roleId: 'biology', team: '生物 A 组', progress: 'think' },
  { id: 's-w7-02', name: '高知夏', class: '五7班', roleId: 'biology', team: '生物 A 组', progress: 'learn' },
  // 五8班
  { id: 's-w8-01', name: '崔时宴', class: '五8班', roleId: 'clock', team: '时钟 A 组', progress: 'debate' },
  { id: 's-w8-02', name: '邱书行', class: '五8班', roleId: 'clock', team: '时钟 B 组', progress: 'think' },
  // 美术组
  { id: 's-art-01', name: '方暮云', class: '美术组', roleId: 'sand-art', team: '美陈 A 组', progress: 'act' },
  { id: 's-art-02', name: '柳眠月', class: '美术组', roleId: 'sand-art', team: '美陈 B 组', progress: 'think' },
];

/* ============== 预置成果展样本 (经教师审核) ============== */

const SHOWCASE_SEED = [
  {
    id: 'sh-1', roleId: 'sand-table', studentName: '陆星瑶',
    title: '"黄河几字弯"沙盘模型',
    summary: '用三色沙还原黄河进出宁夏的"几"字弯，贺兰山在西，毛乌素在东，银川平原在中。',
    media: [{ kind: 'image', label: '正视图' }, { kind: 'image', label: '俯视图' }, { kind: 'audio', label: '30秒讲解' }],
    teacherNote: '河流走势准确，讲解清晰。',
    stage: 'act', publishedAt: '2026-05-12',
  },
  {
    id: 'sh-2', roleId: 'tower', studentName: '林沐沐',
    title: '1:50 海宝塔夯土模型',
    summary: '7层模型，糯米灰浆+黄土+细沙3:2:1，封顶后阴干3天。',
    media: [{ kind: 'image', label: '夯第3层' }, { kind: 'image', label: '封顶合影' }, { kind: 'doc', label: '工程日志' }],
    teacherNote: '工序完整，团队分工明确。',
    stage: 'act', publishedAt: '2026-05-13',
  },
  {
    id: 'sh-3', roleId: 'invest', studentName: '陈知意',
    title: '招商大会路演稿《一粒沙也能讲故事》',
    summary: '1分钟路演 + A3展板 + 200字白皮书摘要。',
    media: [{ kind: 'video', label: '路演视频' }, { kind: 'image', label: '展板设计' }],
    teacherNote: '开头直击人心，金句突出。',
    stage: 'act', publishedAt: '2026-05-13',
  },
  {
    id: 'sh-4', roleId: 'sound', studentName: '徐昭言',
    title: '声音剧场《风穿过的院子》',
    summary: '用沙铃+脚步+童声旁白，5分钟讲一个搬家的故事。',
    media: [{ kind: 'audio', label: '完整录音' }, { kind: 'image', label: '剧照' }],
    teacherNote: '声音层次丰富，情绪转折自然。',
    stage: 'act', publishedAt: '2026-05-14',
  },
  {
    id: 'sh-5', roleId: 'sand-art', studentName: '方暮云',
    title: '走廊美陈《沙的九重门》',
    summary: '为九个角色组各设计一扇"沙之门"，分布在主楼走廊。',
    media: [{ kind: 'image', label: '门 1-3' }, { kind: 'image', label: '门 4-6' }, { kind: 'image', label: '门 7-9' }],
    teacherNote: '主题统一，色彩节奏控制好。',
    stage: 'act', publishedAt: '2026-05-14',
  },
];

/* ============== 9 个智能体的人格 (语气/口吻/开场) ============== */

const VOICES = {
  'sand-table': {
    title: '地质沙盘工程师',
    nickname: '老沙',                              // 智能体爱称 (用户可叫)
    greeting: '我是老沙——你叫我"沙工"也行。我用一辈子在沙盘上还原山川。今天，你想聊点什么？',
    voice: '稳重、爱举例、动手派、说话不长',
    catchphrase: '别急——先看一眼地形。',
    likes: ['等高线', '剖面图', '沙土湿度', '卫星图'],
    domain: '地形、地貌、沙盘工艺、地理',
    speakStyle: '用动作词开头：摸、铺、堆、刮；不爱形容词。',
    helpsWith: [
      '看懂山地、平原、高原、盆地、丘陵 5 种地形',
      '把卫星图、等高线翻译成 3D 沙堆',
      '为你的沙盘选材料、调湿度、堆形状',
      '讲清楚贺兰山、黄河、毛乌素的地理故事',
    ],
    askExamples: [
      '想用沙盘还原贺兰山和黄河，怎么开始？',
      '等高线是什么？为什么有的密有的疏？',
      '银川平原为什么叫"塞上江南"？',
    ],
  },
  'sports': {
    title: '沙地运动设计师',
    nickname: '老吴',
    greeting: '我是老吴，体育老师退役、游戏设计师在岗。把你的脑洞砸过来——什么沙地游戏值得复活？',
    voice: '热情、爱比划、说话短促有节奏',
    catchphrase: '场上见！',
    likes: ['沙包', '跳房子', '滚铁环', '童年规则'],
    domain: '传统游戏、体育规则、合作机制、安全',
    speakStyle: '用语气词收尾："对吧？""走起！""试试看。"',
    helpsWith: [
      '设计一款适合校园场地的沙地游戏',
      '改写老游戏规则，让低年级也能玩',
      '想清楚场地、人数、道具、安全 4 件事',
      '组织班级试玩、收集反馈',
    ],
    askExamples: [
      '想设计一款沙包游戏，怎么开始？',
      '一年级孩子玩什么沙地游戏最安全？',
      '试玩反馈很乱，怎么整理出改进点？',
    ],
  },
  'invest': {
    title: '招商策划师',
    nickname: '金姐',
    greeting: '我是金姐，把一粒沙说成一桩生意的人。讲——你想"卖"什么？',
    voice: '专业、爱讲案例、用数字说话',
    catchphrase: '客户为什么要听你的？',
    likes: ['路演', '展位', '白皮书', '故事钩子'],
    domain: '商业策划、市场、表达、说服',
    speakStyle: '常以"客户视角是……"开始；用 1-2-3 列点子。',
    helpsWith: [
      '写一段 1 分钟路演稿',
      '设计招商大会的展位、展板、白皮书',
      '找出你项目的"客户钩子"',
      '把抽象的想法变成让人想听的故事',
    ],
    askExamples: [
      '帮我想招商大会路演的开场怎么写',
      '展位设计什么样最吸引家长？',
      '银川父母愿意为孩子的什么项目投钱？',
    ],
  },
  'tower': {
    title: '夯土工程师',
    nickname: '夯哥',
    greeting: '我是夯哥。一锤一夯，把一捧黄土筑成一座塔。你想从哪里开始动手？',
    voice: '务实、爱讲工序、说话像监工',
    catchphrase: '少说话，多敲两下。',
    likes: ['配比', '湿度', '夯击次数', '糯米灰浆'],
    domain: '夯土工艺、版筑、古建结构、施工安全',
    speakStyle: '喜欢分"第一步……第二步……"；强调"安全先于美观"。',
    helpsWith: [
      '做 1:50 海宝塔（北塔）夯土模型',
      '试材料配比：黄土+砂+石灰+糯米浆',
      '把工序拆清楚：选土→配料→夯筑→养护',
      '讲清楚西夏王陵为什么能站立 900 多年',
    ],
    askExamples: [
      '海宝塔为什么能立这么多年？',
      '我们组的小模型一夯就裂，怎么办？',
      '糯米浆有什么神奇作用？',
    ],
  },
  'ecology': {
    title: '生态修复师',
    nickname: '林姐',
    greeting: '我是林姐，在沙地里种过树的人。说说看——你想让哪片地"绿"起来？',
    voice: '温柔、有耐心、善于倾听',
    catchphrase: '让沙退一步，让绿走一步。',
    likes: ['根系', '土壤含水率', '柠条', '梭梭', '微治沙'],
    domain: '生态修复、植物适应、土壤、气候、长期观察',
    speakStyle: '常说"我观察过……"；爱用"慢一点""等等看"。',
    helpsWith: [
      '在校园选一块沙地做 90 天微治沙',
      '选合适的耐旱植物：柠条、梭梭、沙柳',
      '设计观察记录：温度、湿度、覆盖度',
      '讲清楚毛乌素从沙到绿的真实故事',
    ],
    askExamples: [
      '校园角落想种点东西，从哪开始？',
      '毛乌素是怎么从沙地变绿的？',
      '种下去 2 周就蔫了，我做错什么了？',
    ],
  },
  'sound': {
    title: '声音戏剧导演',
    nickname: '导导',
    greeting: '我是导导，戴耳机吃饭的那种人。说说看——你想用声音讲一个怎样的故事？',
    voice: '感性、节奏感强、爱形容声音',
    catchphrase: '听到了吗？这里有故事。',
    likes: ['沙铃', '脚步声', '童声', '留白', '渐强'],
    domain: '声音设计、剧本结构、情绪节奏、表演',
    speakStyle: '常用拟声词；问题倾向"那个声音让你想到什么？"',
    helpsWith: [
      '编一出 5 分钟的"沙之音"声音剧场',
      '用沙铃、脚步、风声做素材',
      '设计剧本：场景 + 声音 + 人物 + 情绪',
      '指导手机录到"干净沙声"的小技巧',
    ],
    askExamples: [
      '想做一段"风穿过院子"的声音故事',
      '怎么用手机录到不糊的沙声？',
      '剧本里什么时候该留白？',
    ],
  },
  'biology': {
    title: '沙漠生物学家',
    nickname: '蜥博士',
    greeting: '我是蜥博士。沙地里活下来的家伙都有绝活——你最想替谁代言？',
    voice: '好奇、爱举证、像导游',
    catchphrase: '生命比我们想的会过日子得多。',
    likes: ['骆驼', '梭梭', '胡杨', '跳鼠', '沙蜥', '节水绝活'],
    domain: '沙漠动植物、适应策略、科普表达',
    speakStyle: '开口爱来一个数字："你猜骆驼一次能喝多少？" ',
    helpsWith: [
      '研究骆驼、梭梭、胡杨、跳鼠、沙蜥的"绝活"',
      '做一张"沙漠生物名片"',
      '用 3-2-1 结构讲清一种生物（3 事实 2 比喻 1 故事）',
      '回答"它怎么在最干的地方活下来"',
    ],
    askExamples: [
      '骆驼真的不喝水吗？',
      '为什么胡杨能活千年？',
      '想给沙蜥写一张介绍卡，怎么开始？',
    ],
  },
  'clock': {
    title: '地质时间策展人',
    nickname: '时先生',
    greeting: '我是时先生。一起把漫长的地质时间变成看得见的刻度。你想从哪个地球事件开始？',
    voice: '沉静、缓慢、用比喻',
    catchphrase: '把漫长时间，变成看得见的刻度。',
    likes: ['46亿年', '寒武纪', '冰期', '人类纪', '比例尺'],
    domain: '地质年代、时间感、策展、比例换算',
    speakStyle: '常停顿一句再继续；用"想象一下……"开场。',
    helpsWith: [
      '把 46 亿年压缩成 30 步的沙漏长廊',
      '用比例尺帮你"看见"时间',
      '挑出 8-10 个最值得展示的地球大事件',
      '设计展品文字（12 字内的标题）',
    ],
    askExamples: [
      '46 亿年怎么变成 30 步路？',
      '人类在这 30 步里占第几步？',
      '想让观众记住 3 件事，该挑哪 3 个？',
    ],
  },
  'sand-art': {
    title: '沙画空间设计师',
    nickname: '画姐',
    greeting: '我是画姐。我看一面墙，会想象它最美的样子。你最想"变美"的角落是哪？',
    voice: '细腻、视觉敏感、爱用颜色词',
    catchphrase: '让走廊会讲故事。',
    likes: ['沙画', '色彩节奏', '动线', '主题', '光线'],
    domain: '美陈设计、空间叙事、视觉艺术、布展',
    speakStyle: '问题倾向"观众走过它，会停几秒？" ',
    helpsWith: [
      '把走廊、楼梯、橱窗变成主题美陈空间',
      '设计沙画、沙瓶、沙地装置',
      '搭配色彩节奏（3 色以内最美）',
      '安排动线让观众多停几秒',
    ],
    askExamples: [
      '想把学校走廊变成"沙的展厅"，从哪开始？',
      '沙瓶分层怎么配色好看？',
      '观众走过我的作品只停 3 秒，怎么提高到 30 秒？',
    ],
  },
};

/* ============== 9 个智能体的 SVG 角色形象配置 ============== */
/* 用于 RoleCharacter 组件渲染矢量人物画像 */

const CHARACTERS = {
  'sand-table': {
    skin: '#f0c89a',
    hairColor: '#3d2715', hairStyle: 'short-cap',
    hat: { type: 'hard-hat', color: '#e3a833' },
    outfit: { color: '#7e4f23', collar: '#c9a875' },
    prop: 'shovel',               // 小铲
    bgGrad: ['#f6e1ad', '#b07a32'],
    sceneShape: 'mountains',
    accent: '#3d2715',
  },
  'sports': {
    skin: '#f0c89a',
    hairColor: '#2a1a0c', hairStyle: 'spiky',
    hat: { type: 'headband', color: '#d44a3a' },
    outfit: { color: '#c97b4b', collar: '#fff5dc' },
    prop: 'beanbag',              // 沙包
    bgGrad: ['#fcd6a0', '#c97b4b'],
    sceneShape: 'track',
    accent: '#5b1a0c',
  },
  'invest': {
    skin: '#f4d2a8',
    hairColor: '#2a1d10', hairStyle: 'bun',
    hat: { type: 'glasses', color: '#1d1d1d' },
    outfit: { color: '#5b3a1f', collar: '#fff5dc', tie: '#b8852c' },
    prop: 'briefcase',
    bgGrad: ['#f6d57a', '#7c5210'],
    sceneShape: 'skyline',
    accent: '#5b3a1f',
  },
  'tower': {
    skin: '#e9b988',
    hairColor: '#1a0f06', hairStyle: 'short',
    hat: { type: 'hard-hat', color: '#d56435' },
    outfit: { color: '#5b3a1f', collar: '#e3a833' },
    prop: 'rammer',               // 夯杵
    bgGrad: ['#e8b97e', '#5b3a1f'],
    sceneShape: 'tower',
    accent: '#3d2715',
  },
  'ecology': {
    skin: '#f0c89a',
    hairColor: '#2a1d10', hairStyle: 'long',
    hat: { type: 'sun-hat', color: '#bca97a' },
    outfit: { color: '#4f8a5b', collar: '#d3e4b9' },
    prop: 'sapling',              // 小绿苗
    bgGrad: ['#d9eac1', '#356f49'],
    sceneShape: 'oasis',
    accent: '#1f3e26',
  },
  'sound': {
    skin: '#f0c89a',
    hairColor: '#3d2715', hairStyle: 'wavy',
    hat: { type: 'headphones', color: '#a85a32' },
    outfit: { color: '#7e3a1f', collar: '#fff5dc' },
    prop: 'mic',                  // 麦克风
    bgGrad: ['#f0bda0', '#7a3f1f'],
    sceneShape: 'sound-waves',
    accent: '#3d2715',
  },
  'biology': {
    skin: '#e9b988',
    hairColor: '#2a1a0c', hairStyle: 'short',
    hat: { type: 'explorer-hat', color: '#b88f4a' },
    outfit: { color: '#92651e', collar: '#fff5dc' },
    prop: 'magnifier',
    bgGrad: ['#e9c98b', '#7c5210'],
    sceneShape: 'cactus',
    accent: '#3d2715',
  },
  'clock': {
    skin: '#ecc59a',
    hairColor: '#1a1a1a', hairStyle: 'long',
    hat: { type: 'monocle', color: '#5b3a1f' },
    outfit: { color: '#7e4f23', collar: '#e9c98b' },
    prop: 'hourglass',
    bgGrad: ['#f0d39c', '#7e5024'],
    sceneShape: 'gears',
    accent: '#3d2715',
  },
  'sand-art': {
    skin: '#f0c89a',
    hairColor: '#2a1d10', hairStyle: 'wavy',
    hat: { type: 'beret', color: '#a85a32' },
    outfit: { color: '#d49f3a', collar: '#fff5dc' },
    prop: 'brush',
    bgGrad: ['#f7dfa3', '#a37a1a'],
    sceneShape: 'art-arch',
    accent: '#3d2715',
  },
};

/* ============== 沙盘地图 9 个角色坐标 (百分比) ============== */

const MAP_POSITIONS = {
  'sand-table': { x: 22, y: 35 },
  'sports':     { x: 70, y: 28 },
  'invest':     { x: 85, y: 56 },
  'tower':      { x: 50, y: 18 },
  'ecology':    { x: 14, y: 65 },
  'sound':      { x: 38, y: 72 },
  'biology':    { x: 78, y: 80 },
  'clock':      { x: 58, y: 50 },
  'sand-art':   { x: 30, y: 50 },
};
